import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DateHelper } from './../../models/NgDateCustomAdapter';
import { TipoInformeEnum } from '../../models/enums';
import { InformeService } from '../../services/informe.service';
@Component({
  selector: 'app-informes-download',
  templateUrl: './informes-download.component.html',
  styleUrls: ['./informes-download.component.scss']
})
export class InformesDownloadComponent implements OnInit {

  informesList: any = [
    { id: 'IP1', name: 'Informes en incidencia' },
    { id: 'IP2', name: 'Informes en manos del técnico o validación o en tramitación de alta' },
    { id: 'IP3', name: 'Informes en reclamación' },
    { id: 'IP4', name: 'Seguimiento del plazo' },
    { id: 'IP5', name: 'Seguimiento de facturación' },
  ];

  formGroup: FormGroup;
  requiredDate: boolean = false;
  errorMessage = '';
  closed = false;
  @Input() showTitle: boolean = true;

  constructor(private _fb: FormBuilder, public dateHelper: DateHelper, private informeService: InformeService) { }

  ngOnInit() {
    this.formGroup = this._fb.group({
      tipoInforme: '',
      fechaInicio: [{ value: null, disabled: true }, Validators.required],
      fechaFin: [{ value: '', disabled: true }, Validators.required],
    });
  }

  onChange() {
    let tipoInforme = this.formGroup.value.tipoInforme;
    this.errorMessage = "";
    this.formGroup.patchValue({
      fechaInicio: null,
      fechaFin: null
    });

    if (tipoInforme == TipoInformeEnum[TipoInformeEnum.IP4]) {
      this.formGroup.get('fechaInicio').enable();
      this.formGroup.get('fechaFin').enable();
      this.requiredDate = true;
    } else if (tipoInforme == TipoInformeEnum[TipoInformeEnum.IP5]) {
      this.formGroup.get('fechaInicio').enable();
      this.formGroup.get('fechaFin').enable();
      this.formGroup.patchValue({
        fechaInicio: this.getStartDate(),
        fechaFin: this.dateHelper.dateFormat_iso(new Date())
      });
      this.requiredDate = true;
    } else {
      this.formGroup.get('fechaInicio').disable();
      this.formGroup.get('fechaFin').disable();
      this.requiredDate = false;
    }
  }

  getStartDate(): any {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    return this.dateHelper.dateFormat_iso(new Date(year, 0, 2));
  }

  onDownload() {
    if (this.formGroup.valid) {
      this.getTipoInforme();
      this.errorMessage = "";
    } else {
      this.errorMessage = "Para descargar este informe, es necesario introducir las fechas.";
    }

  }

  getTipoInforme() {
    let tipoInforme = this.formGroup.value.tipoInforme;
    let fechaInicio = this.formGroup.value.fechaInicio ? this.formGroup.value.fechaInicio : null;
    let fechaFin = this.formGroup.value.fechaFin ? this.formGroup.value.fechaFin : null;

    switch (tipoInforme) {
      case TipoInformeEnum[TipoInformeEnum.IP1]:
        this.informeService.getInforme1();
        break;
      case TipoInformeEnum[TipoInformeEnum.IP2]:
        this.informeService.getInforme2();
        break;
      case TipoInformeEnum[TipoInformeEnum.IP3]:
        this.informeService.getInforme3();
        break;
      case TipoInformeEnum[TipoInformeEnum.IP4]:
        this.informeService.getInforme4(fechaInicio, fechaFin);
        break;
      case TipoInformeEnum[TipoInformeEnum.IP5]:
        this.informeService.getInforme5(fechaInicio, fechaFin);
        break;

    }
  }

}
